// src/api.js
import axios from "axios";

const API = axios.create({
  baseURL: "/api", // ✅ matches your Express routes
});

// Automatically attach token to every request if logged in
API.interceptors.request.use((config) => {
  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  if (userInfo?.token) {
    config.headers.Authorization = `Bearer ${userInfo.token}`;
  }
  return config;
});

export default API;
